<label
    *ngIf="labelTextTop"
    [htmlFor]="id"
    [ngClass]="isDisabled ? 'pb-form-label-top--disabled' : ''"
>
    {{ labelTextTop }}
    <!-- <span *ngIf="isRequired">*</span> -->
</label>
<div [ngClass]="{'pb-flex pb-flex-nowrap pb-gap-3' : labelTextBottom, 'pb-items-center' : labelTextBottom && !isTopAligned, 'pb-items-start' : labelTextBottom && isTopAligned}">
    <input
        type="checkbox"
        [id]="id"
        [name]="name"
        [required]="isRequired "
        [disabled]="isDisabled"
        [ngClass]="{'pb-error-showcase' : error}"
        [style.margin-top]="isTopAligned ? '6px !important' : null"
        class="pb-form-checkbox"
        [value]="value"
        [checked]="isChecked"
        (input)="onValueChange($event.target.checked)"
    />
    <label [for]="id" *ngIf="labelTextBottom" appRichTextRouter [innerHTML]="labelTextBottom  | TrustHtml"></label>
</div>
<p [ngClass]="error ? 'pb-text-[#CC0000]' : ''" *ngIf="error">{{ errorMessage }}</p>
